import axios from 'axios';
import { BASE_URL } from './api';

export async function getEngagements(token, queryParams='') {
    return axios({
        method: 'get',
        url: `${BASE_URL}/engagements/${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });
}

export async function getEngagementsSimple(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/engagements/simple-list/`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => response.data);
}

export async function updateEngagement(engagementId, formData, token) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/engagements/${engagementId}/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: formData
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function getEngagementLastInvoice(engagementId, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/engagements/${engagementId}/last-invoice/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => response.data)
}

export async function getEngagementNextInvoiceDefaults(engagementId, token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/engagements/${engagementId}/next-invoice-defaults/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => response.data)
}

export async function pauseEngagement(engagementId, reason, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/engagements/${engagementId}/pause/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: { reason }
    }).then((response) => response)
}

export async function unpauseEngagement(engagementId, reason, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/engagements/${engagementId}/unpause/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: { reason }
    }).then((response) => response)
}

export async function createEngagement(formData, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/engagements/create_engagement/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: formData
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}